export default "__VITE_ASSET__CGGoHCgV__"